'use client';

import {
  CollectionFilter,
  CollectionFilterSkeleton,
} from '@/modules/product/components/collection/CollectionFilter';
import {
  CollectionListGrid,
  CollectionListGridSkeleton,
} from '@/modules/product/components/collection/CollectionListGrid';
import { useSkuSearch } from '@/modules/product/hooks/useSkuSearch';
import { ContentfulCollection } from '@/modules/product/models/collection.interface';

type CollectionContentProps = {
  collection: ContentfulCollection;
  productSkus: string[];
};

export const CollectionContent = ({ collection, productSkus }: CollectionContentProps) => {
  const { validProducts: products, isPending } = useSkuSearch(productSkus);

  if (isPending) {
    return (
      <>
        <CollectionFilterSkeleton />
        <CollectionListGridSkeleton />
      </>
    );
  }

  return (
    <>
      <CollectionFilter collection={collection} products={products} />
      <CollectionListGrid
        products={products}
        collection={collection}
        exactMatches={collection?.products
          ?.filter((product: { sku: string; exactMatch: boolean }) => product.exactMatch)
          ?.map((product: { sku: string }) => product.sku)}
      />
    </>
  );
};
